import * as Sentry from "@sentry/browser";
import type { AxiosResponse } from "axios";

const BODY_PREVIEW_LENGTH = 300;

/** Returns the response body if it is an array. Otherwise reports it to Sentry
 * and returns `cachedData`, or `[]` if nothing is cached. */
export function ensureListResponse<T>(
  response: AxiosResponse<unknown>,
  endpoint: "person" | "generator" | "cellChecks",
  cachedData: Array<T> | undefined
): Array<T> {
  if (Array.isArray(response.data)) {
    return response.data as Array<T>;
  }

  Sentry.captureMessage(
    "Revenue monitoring endpoint returned a non-array body",
    {
      level: "error",
      extra: {
        endpoint,
        requestUrl: response.config?.url,
        responseUrl: response.request?.responseURL,
        status: response.status,
        contentType: response.headers?.["content-type"],
        bodyType: typeof response.data,
        bodyPreview: getBodyPreview(response.data),
        keptCachedData: cachedData !== undefined
      }
    }
  );
  return cachedData ?? [];
}

function getBodyPreview(data: unknown) {
  if (typeof data === "string") {
    return data.slice(0, BODY_PREVIEW_LENGTH);
  }
  if (data !== null && typeof data === "object") {
    return `keys: ${Object.keys(data).join(", ")}`.slice(
      0,
      BODY_PREVIEW_LENGTH
    );
  }
  return String(data);
}
